// Automated Sign In Pop-up Logic
// Handles showing the pop-up for non-logged-in users and auto-closing it.

function openSigninPopup() {
    const overlay = document.querySelector('.signin-popup-overlay');
    if (overlay) {
        overlay.classList.add('active');
    }
}
window.openSigninPopup = openSigninPopup;

function closeSigninPopup() {
    const overlay = document.querySelector('.signin-popup-overlay');
    if (overlay) {
        overlay.classList.remove('active');
    }
}
window.closeSigninPopup = closeSigninPopup;

document.addEventListener('DOMContentLoaded', () => {
    // Check if user is logged in by looking for the "Sign In" button
    // The "Sign In" button only exists if the user is NOT logged in (handled by Liquid)
    const signinBtn = document.querySelector('.btn-signin');

    if (signinBtn) {
        // User is NOT logged in, show pop-up automatically
        // Add a small delay for better UX (so it doesn't jar the user immediately)
        setTimeout(() => {
            openSigninPopup();

            // Auto-close after 7 seconds
            setTimeout(() => {
                closeSigninPopup();
            }, 7000);
        }, 1000);
    }

    // Close on click outside
    const overlay = document.querySelector('.signin-popup-overlay');
    if (overlay) {
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                closeSigninPopup();
            }
        });
    }
});
